import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks';
import { checkPermission, Actions, Subjects } from '@/utils/abilities';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredAction?: Actions;
  requiredSubject?: Subjects;
  requiredRoles?: string[];
  fallbackPath?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredAction = 'read',
  requiredSubject = 'all',
  requiredRoles,
  fallbackPath = '/login',
}) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
console.log(!isAuthenticated)
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role-based access check (simplified)
  if (requiredRoles && requiredRoles.length > 0) {
    const userRole = user?.role;
    if (!userRole || !requiredRoles.includes(userRole)) {
      return <Navigate to="/bookings" replace />; // Redirect to home if no access
    }
  }
  // Legacy CASL permission check (for backward compatibility)
  else if (requiredAction && requiredSubject) {
    const hasPermission = checkPermission(user, requiredAction, requiredSubject);
    if (!hasPermission) {
      return <Navigate to={fallbackPath} replace />;
    }
  }

  return <>{children}</>;
};